(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[id^="arc-ticker-data-"]');
    sections.forEach((dataEl) => {
      const id = dataEl.id.replace('arc-ticker-data-', '');
      const tickEl = document.getElementById('arc-ticker-' + id);
      if (!tickEl) return;
      let lines;
      try {
        lines = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!lines || lines.length < 2) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      let i = 0;
      setInterval(() => {
        i = (i + 1) % lines.length;
        tickEl.classList.add('out');
        setTimeout(() => {
          tickEl.textContent = lines[i];
          tickEl.classList.remove('out');
        }, 400);
      }, 3600);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-rotator"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[id^="arc-rotator-"]').forEach((root) => {
      const frames = root.querySelectorAll('.arc-rframe');
      if (frames.length < 2) return;

      let i = 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function next() {
        frames[i].classList.remove('active');
        i = (i + 1) % frames.length;
        frames[i].classList.add('active');
      }

      root.addEventListener('click', next);

      if (!reduceMotion) {
        setInterval(next, 4200);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (function () {
    const container = document.getElementById('arc-cart-content');
    if (!container) return;

    function bindRemove() {
      container.querySelectorAll('[data-arc-cart-remove]').forEach((btn) => {
        btn.addEventListener('click', () => removeLine(btn.dataset.lineKey));
      });
    }

    function removeLine(key) {
      if (!key || !window.routes) return;
      const line = container.querySelector('[data-line-key="' + key + '"].arc-cline');
      if (line) line.classList.add('is-removing');

      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      })
        .then(() => fetch(window.location.pathname + '?section_id=' + container.dataset.sectionId))
        .then((r) => r.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.getElementById('arc-cart-content');
          if (newContent) {
            container.innerHTML = newContent.innerHTML;
            bindRemove();
          }
          return fetch(window.routes.cart_url + '.js');
        })
        .then((r) => r.json())
        .then((cart) => {
          document.querySelectorAll('.arc-hcart .n').forEach((el) => {
            el.textContent = cart.item_count;
          });
        })
        .catch(() => {
          if (line) line.classList.remove('is-removing');
        });
    }

    bindRemove();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-arc-product]').forEach((root) => {
      const sizeButtons = root.querySelectorAll('.arc-size');
      const addBtn = root.querySelector('[data-arc-add]');
      const addLabel = addBtn ? addBtn.querySelector('.arc-add-label') : null;
      const addPrice = addBtn ? addBtn.querySelector('.arc-add-price') : null;

      sizeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          sizeButtons.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          if (addBtn) {
            addBtn.dataset.variantId = btn.dataset.variantId;
            if (addPrice && btn.dataset.variantPrice) {
              addPrice.textContent = addPrice.textContent.replace(/[\d.,]+/, () => {
                const cents = parseInt(btn.dataset.variantPrice, 10);
                return (cents / 100).toString().replace('.', ',');
              });
            }
          }
        });
      });

      function addToCart(id, label) {
        if (!id || !window.routes) return;

        if (label) {
          if (label.dataset.original === undefined) {
            label.dataset.original = label.textContent;
          }
          clearTimeout(label._arcRevertTimer);
          label.textContent = 'added ✓';
          label._arcRevertTimer = setTimeout(() => {
            label.textContent = label.dataset.original;
          }, 1400);
        }

        const addUrl = window.routes.cart_add_url + '.js';
        const cartUrl = window.routes.cart_url + '.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
        })
          .then((r) => r.json())
          .then(() => fetch(cartUrl))
          .then((r) => r.json())
          .then((cart) => {
            document.querySelectorAll('.arc-hcart .n').forEach((el) => {
              el.textContent = cart.item_count;
            });
          })
          .catch(() => {});
      }

      if (addBtn) {
        addBtn.addEventListener('click', () => addToCart(addBtn.dataset.variantId, addLabel));
      }
      const crossBtn = root.querySelector('[data-arc-cross-sell]');
      const crossLabel = crossBtn ? crossBtn.querySelector('.arc-add-label') : null;
      if (crossBtn) {
        crossBtn.addEventListener('click', () => addToCart(crossBtn.dataset.variantId, crossLabel));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
